import type { BanDich } from '../types';
import type { viCanhBao } from './canh-bao.vi';

export const enCanhBao: Pick<BanDich, keyof typeof viCanhBao> = {
  canhBao: {
    nhanNav: 'Alerts',
    moNav: 'Notification channels, alert tasks and delivery log',
    nhanNavTenant: 'Alerts and notifications',
    tieuDe: 'Alerts and notifications',
    moTaTenant:
      'Set up notification channels such as Email and Telegram, create alert tasks for your organisation and review what was sent.',
    moTaNenTang:
      'Channels and alert tasks for the operations team, the channel catalogue per plan, and delivery monitoring across all tenants.',
    tabTacVu: 'Alert list',
    tabKenh: 'Channel settings',
    tabNhatKy: 'Alert log',
    tabDanhMuc: 'Catalogue',
    tabGiamSat: 'Delivery monitor',
    suDung: '{{so}} / {{toiDa}} messages sent this month',
    suDungKhongGioiHan: '{{so}} messages sent this month',
    suDungGanHet: '{{phanTram}}% of this month’s message quota used.',

    themTacVu: 'Add task',
    themTacVuDauTien: 'Add your first task',
    bangTacVu: 'Alert tasks',
    cotTieuDe: 'Task',
    cotBat: 'On',
    cotKenh: 'Send via',
    cotDieuKien: 'Condition',
    cotKiemCuoi: 'Last checked',
    cotDaGui: 'Sent',
    theoSuKien: 'On event',
    soLan: '{{so}} times',
    themSo: '+{{so}}',
    kenhDaGo: 'No channel left',
    moiLanXayRa: 'Every occurrence',
    rongTacVu: 'No alert tasks yet',
    rongTacVuMo:
      'Each task picks an event type, a threshold and the channels to notify. If you have no channel yet, create one on the Channel settings tab first.',
    loiTacVu: 'Couldn’t load the alert list: {{loi}}',
    suaTacVu: 'Edit task',
    xemLichSu: 'View history',
    xoaTacVu: 'Delete task',
    batTatNhan: 'Turn {{ten}} on or off',
    daThemTacVu: 'Task {{ten}} added.',
    daLuuTacVu: 'Task {{ten}} saved.',
    daBatTacVu: '{{ten}} turned on.',
    daTatTacVu: '{{ten}} turned off.',
    daXoaTacVu: 'Task {{ten}} deleted.',

    hopThem: 'Add alert task',
    hopSua: 'Edit alert task',
    truongLoai: 'Alert type',
    chonLoai: 'Choose an alert type',
    nhomTenant: 'Organisation',
    truongTieuDe: 'Task name',
    tieuDeGoiY: 'Shown in the list and in the log.',
    truongKenh: 'Send via',
    kenhGoiY: 'Choose one or more channel settings.',
    chuaCoKenhNao: 'No channel settings yet.',
    moCauHinhKenh: 'Open channel settings',
    chuaCauHinhLoai: '{{kenh}}: not set up',
    kenhDangTat: '{{ten}} (off)',
    caiDatNangCao: 'Advanced settings',
    toiDaNgay: 'Daily limit',
    toiDaTong: 'Total limit',
    deTrongKhongGioiHan: 'Leave empty for no limit.',
    khoangCach: 'Minimum interval (seconds)',
    khoangCachGoiY: '600 seconds is 10 minutes.',
    khungGioTu: 'Send from',
    khungGioDen: 'to',
    khungGioGoiY: 'Nothing is sent outside this window. Critical messages are still sent outside it.',
    batSauLuu: 'Turn the task on now',
    loiGioiHan: 'Enter a whole number of 1 or more, or leave it empty.',
    loiKhoangCach: 'Enter a number of seconds from 0 to 604,800.',
    loiChonKenh: 'Choose at least one channel.',
    loiChonLoai: 'Choose an alert type.',
    loiTieuDe: 'Enter a task name.',
    loiKhungGio: 'Use HH:mm, for example 08:00.',
    nutThemTacVu: 'Add task',
    nutLuuTacVu: 'Save task',
    xnXoaTieuDe: 'Delete task {{ten}}?',
    xnXoaThan:
      'The task stops checking and sends nothing more. Its log is kept until the retention period ends. This can’t be undone.',
    dangXoa: 'Deleting...',
    dangLuu: 'Saving...',
  },

  canhBaoKenh: {
    bang: 'Notification channel types',
    cotKenh: 'Channel',
    cotCauHinh: 'Settings',
    chuaCauHinh: 'Not set up',
    soCauHinh: '{{so}} settings',
    soDangTat: '{{so}} off',
    xemHuongDan: 'View guide',
    huongDanTieuDe: 'Connecting {{kenh}}',
    moCauHinh: 'Open {{kenh}} settings',
    nganTieuDe: '{{kenh}} settings',
    them: 'Add settings',
    themDauTien: 'Add your first settings',
    rongNgan: 'No {{kenh}} settings yet',
    rongNganMo: 'Add settings so alert tasks can send via {{kenh}}.',
    rongLoai: 'No channel type is turned on',
    rongLoaiMo: 'The platform administrator hasn’t enabled any channel type for the current plan.',
    loiDanhSach: 'Couldn’t load channel settings: {{loi}}',
    dangBat: 'On',
    dangTat: 'Off',
    tuTat: 'Turned off after repeated errors',
    thuDuocLuc: 'Test succeeded at {{luc}}',
    thuHongLuc: 'Test failed at {{luc}}: {{loi}}',
    chuaThu: 'Not tested yet',
    guiThu: 'Send test',
    sua: 'Edit',
    bat: 'Turn on',
    tat: 'Turn off',
    go: 'Remove settings',
    guiThuDuoc: 'Test message sent via {{ten}}.',
    guiThuHong: 'Test via {{ten}} failed: {{loi}}',
    daThem: 'Settings {{ten}} added.',
    daLuu: 'Settings {{ten}} saved.',
    daBat: '{{ten}} turned on.',
    daTat: '{{ten}} turned off.',
    daGo: 'Settings {{ten}} removed.',
    hopThem: 'Add {{kenh}} settings',
    hopSua: 'Edit {{kenh}} settings',
    truongTen: 'Settings name',
    tenGoiY: 'For example: Operations group, Accounting.',
    loiTen: 'Enter a settings name.',
    daLuuSecret: 'Saved. Leave empty to keep it.',
    nutThem: 'Add settings',
    nutLuu: 'Save settings',
    batCauHinh: 'Turn these settings on',
    layChatId: 'Get chat ID',
    canToken: 'Enter the bot token first.',
    khongThayChat: 'The bot hasn’t received any message. Message the bot or add it to a group, then try again.',
    chonChat: 'Choose the chat to notify',
    loiChat: 'Couldn’t load chats: {{loi}}',
    xnGoTieuDe: 'Remove settings {{ten}}?',
    xnGoThan:
      'The secret of these settings is deleted. Tasks using them no longer send here, and pending deliveries are cancelled. This can’t be undone.',
    dangGo: 'Removing...',
  },

  canhBaoNhatKy: {
    bang: 'Alert log',
    cotThoiGian: 'Time',
    cotTacVu: 'Task',
    cotLoai: 'Type',
    cotMuc: 'Severity',
    cotNoiDung: 'Content',
    cotTrangThai: 'Status',
    cotTenant: 'Scope',
    locTrangThai: 'Filter by status',
    moiTrangThai: 'All statuses',
    locTacVu: 'Filter by task',
    moiTacVu: 'All tasks',
    rong: 'No alerts sent yet',
    rongMo: 'Every time a task fires, including when a sending limit holds it back, a row appears here.',
    rongLoc: 'No alerts match the filter',
    loi: 'Couldn’t load the log: {{loi}}',
    taiThem: 'Load more',
    soKenh: '{{dat}}/{{tong}} channels',
    tacVuDaXoa: 'Deleted task',
    nenTang: 'Platform',
    xemChiTiet: 'View details of {{ten}}',
    chiTiet: 'Alert details',
    noiDung: 'Content',
    cacLanGui: 'Delivery per channel',
    khongGui: 'Not sent through any channel.',
    lyDo: 'Why it wasn’t sent',
    xayRaLuc: 'Occurred at',
    thuLan: 'Attempt {{so}}',
    doTre: '{{so}} ms',
    http: 'HTTP {{ma}}',
    thuLaiLuc: 'Retry at {{luc}}',
    guiLai: 'Resend',
    dangGuiLai: 'Resending...',
    daXepGuiLai: 'Resend queued.',
    laGuiLai: 'Resend of an earlier delivery',
    loiChiTiet: 'Couldn’t load details: {{loi}}',
    soLanThu: '{{so}} attempts',
  },

  canhBaoNenTang: {
    kpiCanhBao: 'Alerts in 24 hours',
    kpiDaGui: 'Sent',
    kpiLoi: 'Failed',
    kpiChan: 'Held back by limits',
    kpiCho: 'Waiting to send',
    kpiHetLuot: 'Out of retries',
    theoKenh: 'By channel, last 24 hours',
    theoKenhDong: '{{dat}} succeeded, {{loi}} failed',
    loiTongQuan: 'Couldn’t load the overview: {{loi}}',
    locPhamVi: 'Filter by scope',
    moiPhamVi: 'All tenants and platform',
    chiNenTang: 'Platform only',
    motTenant: 'One tenant',
    maTenant: 'Tenant ID (UUID)',
    maTenantSai: 'A tenant ID is a UUID, for example 0a7d3c5e-1f2b-4e6a-9c8d-000000000005.',
    bangLoaiKenh: 'Channel types',
    bangLoaiCanhBao: 'Alert types',
    cotBat: 'On',
    cotGoi: 'Available on plans',
    cotNguon: 'Data source',
    cotPhamVi: 'Scope',
    cotKichHoat: 'Trigger',
    cotPhienBan: 'Adapter version',
    chuaCoNguon: 'No source yet',
    coNguon: 'Ready',
    phamViTenant: 'Tenant',
    phamViNenTang: 'Platform',
    dinhKy: 'Checked every {{phut}} min',
    daLuuDanhMuc: 'Catalogue saved.',
    loiDanhMuc: 'Couldn’t load the catalogue: {{loi}}',
    batNhan: 'Turn {{ten}} on or off',
    goiNhan: 'Plans for {{ten}}',
    rongDanhMuc: 'The catalogue is empty',
  },

  canhBaoMa: {
    kenh: {
      TELEGRAM: 'Telegram',
      EMAIL: 'Email',
      WEBHOOK: 'Webhook',
      DISCORD: 'Discord',
      DINGTALK: 'DingTalk',
      WECOM: 'WeCom',
      FEISHU: 'Feishu',
    },
    moKenh: {
      TELEGRAM: 'Send through a Telegram bot to a chat or group.',
      EMAIL: 'Send email through your own SMTP server or the platform mail server.',
      WEBHOOK: 'Call your organisation’s system over HTTPS, signed with HMAC.',
      DISCORD: 'Post to a Discord channel through a webhook.',
      DINGTALK: 'Send through a DingTalk group robot.',
      WECOM: 'Send through a WeCom group robot.',
      FEISHU: 'Send through a Feishu or Lark group robot.',
    },
    huongDan: {
      TELEGRAM:
        '1. In Telegram, send /newbot to @BotFather and follow the steps to create a bot; BotFather replies with the bot token.\n2. Send the bot any message, or add the bot to the group that should receive alerts.\n3. Add settings, paste the bot token, click Get chat ID and pick the chat.\n4. Save, then click Send test.',
      EMAIL:
        '1. Without your own mail server, turn on "Use the platform mail server" and enter only the recipients.\n2. With your own SMTP: port 465 is SSL/TLS (recommended), 587 is STARTTLS. Unencrypted connections aren’t accepted.\n3. One recipient per line. A shared mailbox keeps alerts flowing when people leave.\n4. Save, then click Send test.',
      WEBHOOK:
        '1. Prepare a public HTTPS address that accepts POST or PUT. Internal network addresses aren’t accepted.\n2. The default body is JSON with title, message, type, severity and occurred_at. To format it yourself, fill in the custom body using the variables listed under that field.\n3. Enter a signing key to verify the X-Platform-Signature header (HMAC-SHA256) on your side.\n4. Save, then click Send test.',
      DISCORD:
        '1. In Discord, open the channel settings → Integrations → Webhooks → New webhook.\n2. Copy the webhook URL into the settings.\n3. Save, then click Send test.',
      DINGTALK:
        '1. In the DingTalk group, add a custom robot and choose signing as its security option.\n2. Copy the robot URL and signing key into the settings.\n3. Save, then click Send test.',
      WECOM:
        '1. In the WeCom group, add a group robot.\n2. Copy the robot’s webhook URL into the settings.\n3. Save, then click Send test.',
      FEISHU:
        '1. In the Feishu or Lark group, add a custom robot and turn on signature verification if you want it.\n2. Copy the webhook URL and signing key into the settings.\n3. Save, then click Send test.',
    },
    muc: { INFO: 'Info', WARNING: 'Warning', CRITICAL: 'Critical' },
    banGhi: {
      PENDING: 'Sending',
      SENT: 'Sent',
      PARTIAL: 'Partly sent',
      FAILED: 'Failed',
      SUPPRESSED: 'Held back',
    },
    gui: {
      PENDING: 'Waiting',
      PROCESSING: 'Sending',
      SUCCEEDED: 'Succeeded',
      RETRY_SCHEDULED: 'Retry scheduled',
      FAILED_PERMANENT: 'Failed',
      DEAD_LETTERED: 'Out of retries',
      CANCELLED: 'Cancelled',
    },
    lyDo: {
      DAILY_LIMIT: 'Daily limit reached',
      TOTAL_LIMIT: 'Total limit reached',
      MIN_INTERVAL: 'Minimum interval not yet passed',
      SEND_WINDOW: 'Outside the sending window',
      QUOTA: 'Monthly message quota used up',
      NOT_ENTITLED: 'No longer included in the plan',
      TENANT_INACTIVE: 'Organisation is suspended',
      NO_CHANNEL: 'No channel left turned on',
    },
    loiGui: {
      AUTH_FAILED: 'Wrong credentials',
      NOT_FOUND: 'Target not found',
      RATE_LIMITED: 'Rate limited',
      TIMEOUT: 'Timed out',
      NETWORK: 'Network error',
      TARGET_FORBIDDEN: 'Target blocked',
      BAD_REQUEST: 'Invalid request',
      SERVER_ERROR: 'Target server error',
      CONFIG_INVALID: 'Invalid settings',
      CHANNEL_DISABLED: 'Channel is off',
      UNKNOWN: 'Unknown error',
    },
    ketQua: {
      SUCCEEDED: 'Succeeded',
      TRANSIENT_ERROR: 'Temporary error',
      PERMANENT_ERROR: 'Permanent error',
    },
    goi: {
      TRIAL: 'Trial',
      STANDARD: 'Standard',
      PROFESSIONAL: 'Professional',
      ENTERPRISE: 'Enterprise',
    },
    loiTruong: {
      batBuoc: 'Enter a value for this field.',
      emailSai: 'An email address is malformed. Put one address per line.',
      soNgoaiKhoang: 'The number is out of the allowed range.',
      jsonSai: 'The JSON has a syntax error.',
      urlSai: 'The address must start with https://.',
      gioSai: 'Use HH:mm for the time.',
    },
  },

  canhBaoTruong: {
    TELEGRAM: { chat_id: 'Chat ID', bot_token: 'Bot token' },
    EMAIL: {
      use_platform_smtp: 'Use the platform mail server',
      smtp_host: 'SMTP server',
      smtp_port: 'SMTP port',
      sender: 'Sender email',
      smtp_username: 'SMTP username',
      smtp_password: 'SMTP password',
      recipients: 'Recipients',
    },
    WEBHOOK: {
      url: 'URL',
      method: 'Method',
      content_type: 'Format',
      body_template: 'Custom body (JSON)',
      headers: 'Headers (JSON)',
      signing_secret: 'HMAC signing key',
    },
    DISCORD: { webhook_url: 'Webhook URL' },
    DINGTALK: { webhook_url: 'Robot URL', signing_secret: 'Signing key' },
    WECOM: { webhook_url: 'Robot URL' },
    FEISHU: { webhook_url: 'Robot URL', signing_secret: 'Signing key' },
  },

  canhBaoGoiY: {
    TELEGRAM: {
      chat_id: 'A user ID, or a group ID (starts with -).',
      bot_token: 'Looks like 123456789:AAH…, issued by @BotFather.',
    },
    EMAIL: {
      use_platform_smtp: 'When on, only the recipients are needed; messages count toward the monthly quota.',
      smtp_host: 'For example smtp.company.com.',
      smtp_port: '465 is SSL/TLS (recommended), 587 is STARTTLS.',
      sender: 'The address shown as the sender.',
      smtp_username: 'Leave empty if it’s the sender email.',
      smtp_password: 'Kept in the secret store and never shown again.',
      recipients: 'One address per line.',
    },
    WEBHOOK: {
      url: 'Only https:// to a public Internet address.',
      method: 'POST or PUT.',
      content_type: 'Content type of the request body.',
      body_template: 'Leave empty to use the default body. Available variables:',
      headers: 'JSON such as {"Authorization": "Bearer …"}. Kept in the secret store.',
      signing_secret: 'When set, each request carries an X-Platform-Signature header.',
    },
    DISCORD: { webhook_url: 'Looks like https://discord.com/api/webhooks/….' },
    DINGTALK: {
      webhook_url: 'Looks like https://oapi.dingtalk.com/robot/send?access_token=….',
      signing_secret: 'The key starts with SEC.',
    },
    WECOM: {
      webhook_url: 'Looks like https://qyapi.weixin.qq.com/cgi-bin/webhook/send?key=….',
    },
    FEISHU: {
      webhook_url: 'Looks like https://open.feishu.cn/open-apis/bot/v2/hook/….',
      signing_secret: 'The robot’s signature verification key.',
    },
  },

  canhBaoLoai: {
    ten: {
      subscription_expiring: 'Service plan expiring',
      license_expiring: 'License expiring',
      quota_ai_tokens: 'AI token quota',
      quota_users: 'User quota',
      quota_storage: 'Storage quota',
      quota_notifications: 'Notification message quota',
      security_login_failed: 'Repeated failed sign-ins',
      security_user_locked: 'Account locked',
      security_admin_login: 'Administrator signed in',
      security_alert: 'Security alert',
      security_ip_blocked: 'IP blocked',
      domain_verification_lost: 'Domain verification lost',
      module_unavailable: 'Module not responding',
      module_event: 'Module event',
      notify_channel_failed: 'Notification channel failing',
      infra_metric: 'Server resources',
      infra_alertmanager: 'Infrastructure alert (Alertmanager)',
      platform_service_down: 'Service not responding',
      platform_kafka_lag: 'Kafka falling behind',
      platform_dead_letter: 'Messages out of retries rising',
      platform_security_critical: 'Critical security',
      platform_ops_warning: 'Operations warning',
      platform_license_expiring: 'Tenant license expiring',
      platform_ai_token_request: 'Extra AI token request',
      platform_tenant_over_quota: 'Tenant over quota',
    },
    mo: {
      subscription_expiring: 'Warns before the service plan term ends.',
      license_expiring: 'Warns before the on-premise installation license expires.',
      quota_ai_tokens: 'Warns when this month’s AI tokens reach the chosen level.',
      quota_users: 'Warns when the number of users nears the plan quota.',
      quota_storage: 'Warns when data storage nears the plan quota.',
      quota_notifications: 'Warns when this month’s alert messages near the quota.',
      security_login_failed: 'Warns when many sign-ins fail within a short time.',
      security_user_locked: 'Warns when an account is temporarily locked after failed sign-ins or an unusual session.',
      security_admin_login: 'Notifies every time an administrator signs in.',
      security_alert: 'Notifies when one of the organisation’s security alert rules fires.',
      security_ip_blocked: 'Notifies when an IP is blocked.',
      domain_verification_lost: 'Notifies when a DNS recheck no longer finds the verification record.',
      module_unavailable: 'Notifies when a module the organisation uses stops responding.',
      module_event: 'Notifies when a module emits the chosen event, for example OCR finished.',
      notify_channel_failed:
        'Notifies through the remaining channels when channel settings turn themselves off after repeated errors.',
      infra_metric: 'Warns when CPU, memory, disk or load stays over the threshold for a while.',
      infra_alertmanager: 'Forwards Alertmanager alerts.',
      platform_service_down: 'Warns when a service isn’t ready.',
      platform_kafka_lag: 'Warns when a Kafka consumer falls behind past the threshold.',
      platform_dead_letter: 'Warns when messages out of retries rise unusually.',
      platform_security_critical: 'Password spraying, repeated session locks, broken audit hash chain.',
      platform_ops_warning: 'Operations warnings from platform services.',
      platform_license_expiring: 'An on-premise tenant’s license is about to expire.',
      platform_ai_token_request: 'A tenant requested extra AI tokens.',
      platform_tenant_over_quota: 'Warns when a tenant uses up its monthly message quota.',
    },
    thamSo: {
      days_before: 'Days in advance',
      threshold_percent: 'Threshold (%)',
      count: 'Count',
      window_minutes: 'Within (minutes)',
      min_severity: 'Minimum severity',
      level: 'Usage level',
      lag_threshold: 'Minimum lag (messages)',
      metric: 'Metric',
      duration_minutes: 'Lasting (minutes)',
    },
    tuyChon: {
      CPU: 'CPU',
      MEMORY: 'Memory',
      DISK: 'Disk',
      LOAD: 'System load',
      '80': '80%',
      '100': '100%',
      INFO: 'Info',
      WARNING: 'Warning',
      CRITICAL: 'Critical',
    },
  },
};
